export const PREFERRED_COUNTRIES = ["us", "fr", "it"];
